import { Injectable } from '@angular/core';
import { BaseGridSource, ComparisonType, PagedModel } from 'components';
import { of } from 'rxjs';
import { catchError, finalize, map, take } from 'rxjs/operators';
import { LocationsWrapperService } from 'src/app/core/services/service-wrappers/locations-wrapper.service';

@Injectable()
export class LocationsService extends BaseGridSource<any> {

  activeFilter: string = '';

  constructor(private service: LocationsWrapperService) {
    super();
  }
  
  load(pagedModel: PagedModel) {

    this.loadingSubject.next(true);

    if (!pagedModel?.propertySearches?.find(p => p.propertyName === "inactive")) {
      if (this.activeFilter === "active") {
        pagedModel.propertySearches.push({
          propertyName: 'inactive',
          comparisonType: ComparisonType.Equals,
          value: 'No'
        });
      } else if (this.activeFilter === "inactive") {
        pagedModel.propertySearches.push({
          propertyName: 'inactive',
          comparisonType: ComparisonType.Equals,
          value: 'Yes'
        });
      }
    }

    this.service
      .apiV1LocationAllPost(pagedModel)
      .pipe(
        map((response) => {
     
          this.itemCountSubject.next(response.metaData.totalItemCount);
        
          return response;
        }),
        catchError(() => of({ data: [] })),
        finalize(() => {
          this.loadingSubject.next(false);
        }),
        take(1)
      )
      .subscribe((data) => this.dataSourceSubject.next(data.data));
  }
}
